// Lib
import { FC, useEffect, useState } from "react";
// Api
import { useUpdateUserMutation } from "rtkQuery/query/usersAPI";
// Hooks
import { useNotification, useViewport } from "hooks";
// Actions
// Selectors
// Types
// Theme
// Constants
// Helpers
// Utils
import { errorHandler } from "utils/errorHandler";
// Icons
// Layouts
// Components
import { Switch } from "components/Form";
// Styled
import { FlexContainer } from "styled/Box";
import { Typography } from "styled/Typography";

interface ColdKitchenStatusProps {
  id: string;
  isLoading: boolean;
  isColdKitchen: boolean | undefined;
}

export const ColdKitchenStatus: FC<ColdKitchenStatusProps> = ({
  id,
  isLoading,
  isColdKitchen,
}) => {
  const { openNotification } = useNotification();

  const { isMobile } = useViewport();

  const [update, { isLoading: isUpdateLoading }] = useUpdateUserMutation();

  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (typeof isColdKitchen === "boolean") {
      setIsChecked(isColdKitchen);
    }
  }, [isColdKitchen]);

  const handleStatusChange = async (value: boolean) => {
    try {
      setIsChecked(value);

      await update({ id, isColdKitchen: value }).unwrap();
    } catch (error) {
      errorHandler({ error, openNotification });
      setIsChecked(!value);
    }
  };

  return (
    <FlexContainer
      $align={isMobile ? "flex-end" : "center"}
      $fullwidth={isMobile}
      $justify={isMobile ? "flex-end" : "center"}
      $gap={10}
    >
      <Typography.Title style={{ textAlign: "right" }}>
        Cold kitchen with cash payment
      </Typography.Title>
      <Switch
        loading={isLoading || isUpdateLoading}
        checked={isChecked}
        onChange={value => handleStatusChange(value)}
      />
    </FlexContainer>
  );
};
